import { ApiConfig, handleResponse } from './config';
import type { Expert, ExpertRegistrationData, ExpertDashboardData, ExpertBrowseResponse } from '../../types/expert';
import type { Module } from '../../types/module';

export class ExpertService {
  constructor(private config: ApiConfig) {}

  private getAuthHeaders(): Record<string, string> {
    const headers = { ...this.config.headers };

    if (typeof window !== 'undefined') {
      try {
        const authStorage = JSON.parse(localStorage.getItem('auth-storage') || '{}');
        const token = authStorage.state?.token;
        if (token && token !== 'null' && token !== 'undefined' && token !== '') {
          headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        // Keep existing headers
      }
    }

    return headers;
  }

  async getAllExperts(page = 1, limit = 20, specialty?: string): Promise<ExpertBrowseResponse> {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (specialty) params.set('specialty', specialty);

    const response = await fetch(`${this.config.baseUrl}/experts?${params}`, {
      headers: this.config.headers
    });

    return handleResponse(response);
  }

  async getExpertById(expertId: string): Promise<Expert> {
    const response = await fetch(`${this.config.baseUrl}/experts/${expertId}`, {
      headers: this.config.headers
    });

    return handleResponse(response);
  }

  async registerAsExpert(data: ExpertRegistrationData): Promise<Expert> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/experts/register`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data)
    });

    return handleResponse(response);
  }

  async updateProfile(data: Partial<ExpertRegistrationData>): Promise<Expert> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/experts/profile`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data)
    });

    return handleResponse(response);
  }

  async getDashboard(): Promise<ExpertDashboardData> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/experts/dashboard/stats`, {
      headers
    });

    return handleResponse(response);
  }

  async getMyModules(status?: string): Promise<Module[]> {
    const headers = this.getAuthHeaders();
    const params = status ? `?status=${status}` : '';
    const response = await fetch(`${this.config.baseUrl}/experts/dashboard/modules${params}`, {
      headers
    });

    return handleResponse(response);
  }
}
